import axios from "axios";
import { getCookie } from "utils/setCookie";

export const getListAnswers = async (id: string): Promise<any> => {
  let url = process.env.REACT_APP_AJAX_URL + `test/user/detail/${id}`;

  try {
    const axiosConfig = {
      headers: {
        "X-Authorization": getCookie("session"),
      },
    };
    const response = await axios.get(url, axiosConfig);
    return response.data;
  } catch (error) {
    console.error(error);
    return { isError: true };
  }
};
export const getListTest = async (params: {
  type: string | string[];
  order_by?: string;
}) => {
  const url = process.env.REACT_APP_AJAX_URL + `test/list`;
  const options = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
    params,
  };
  try {
    const response = await axios.get(url, options);
    return response.data;
  } catch (error: any) {
    console.error("Failed ", error);
    return { isError: true };
  }
};
export const getListTestAnswers = async (params: {
  test_id: string;
  order_by?: string;
}): Promise<any> => {
  const url = process.env.REACT_APP_AJAX_URL + `test/user/list`;
  const options = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
    params,
  };
  try {
    const response = await axios.get(url, options);
    return response;
  } catch (error: any) {
    console.error("Failed ", error);
    return { isError: true };
  }
};
export const UpdatePoint = async (data: {
  _id: string;
  band_detail: { [key: string]: number };
  [key: string]: any;
}) => {
  const url = process.env.REACT_APP_AJAX_URL + `test/user/update`;
  const options = {
    headers: {
      "X-Authorization": getCookie("session"),
    },
  };
  try {
    const response = await axios.post(url, data, options);
    return response.data;
  } catch (error: any) {
    console.error("Failed ", error);
    return { isError: true };
  }
};
